module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "landscape-block-wrapper",
    class: {
      fadeIn: _vm.show
    }
  }, [_c('div', {
    staticClass: "w-100 text-center content-wrapper"
  }, [_c('div', {
    staticClass: "message-1"
  }, [_vm._v("PLEASE ROTATE YOUR PHONE")]), _c('div', {
    staticClass: "icon-rotate"
  }, [_c('icon-rotate', {
    attrs: {
      "width": "70",
      "height": "70"
    }
  })], 1), _vm._m(0)]), _c('div', {
    staticClass: "invader"
  }, [_c('fall-invader', {
    attrs: {
      "width": "262",
      "height": "79"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-2"
  }, [_vm._v("This experience is best enjoyed "), _c('br'), _vm._v(" in portrait")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f094659","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/common/LandscapeBlock.vue
// module id = 1768
// module chunks = 11